import React, {useRef} from 'react';
import CartController from "./CartController";
import {formatNumber} from "../helpers/formatHelper";
import {ToSeoUrl} from "../common/app";

function MainView(props) {
    const {method, state} = CartController(props);
    const checkboxRefs = useRef([]);
    const triggerCheckBox = (i) => {
        const check = checkboxRefs.current[i];
        if (check){
            check.click();
        }
    }
    return (<section className="shopping-card-container" id="shopping-card">
        <div className="shopping-card-header"></div>
        <div className="shopping-card-body">
            {
                state.listProduct?.length === 0 &&
                (<div className="shopping-card-empty">
                    <p className="shopping-card-empty__desc">Bạn chưa có sản phẩm nào trong giỏ hàng. Vui lòng chọn sản
                        phẩm</p>
                    <a className="btn btn-custom-default shopping-card-empty__btn" href="/danh-sach-san-pham">Chọn sản
                        phẩm</a>
                </div>)
            }
            {
                (state.listProduct?.length > 0) && (
                    <div className="">
                        <table className="shopping-card__table">
                            <thead>
                            <tr>
                                <th className="text-center">
                                    <div className="group-check-box">
                                        <input id="shopping-checkbox-check-all" type="checkbox"
                                               checked={method.isCheckAll()}
                                               onChange={method.clickAll}
                                        />
                                        <label htmlFor="shopping-checkbox-check-all"></label>
                                    </div>
                                </th>
                                <th>Sản phẩm</th>
                                <th className="text-center d-none d-xl-table-cell">Đơn giá</th>
                                <th className="text-center d-none d-md-table-cell d-xl-none">Số lượng</th>
                                <th className="text-center d-none d-xl-table-cell">Số lượng</th>
                                <th className="text-center d-none d-xl-table-cell">Thành tiền</th>
                                <th className="text-center d-none d-xl-table-cell"></th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                state.listProduct?.map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className="text-center">
                                                <div className="group-check-box">
                                                    <input type="checkbox"
                                                           ref={(el) => checkboxRefs.current[i] = el}
                                                           id={"shopping-checkbox-check-" + item?.productSimilar?.id}
                                                           checked={method.isChecked(item?.productSimilar?.id)}
                                                           value={item?.productSimilar?.id}
                                                           onChange={method.productCheck}/>
                                                    <label
                                                        htmlFor={"shopping-checkbox-check-" + item?.productSimilar?.id}></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="product-content-info cursor-pointer">
                                                    <div className="product-info__image-wrap" onClick={(e) => triggerCheckBox(i)}>
                                                        <div className="product-info__image"
                                                             style={{backgroundImage: "url(" + item?.products.image + ")"}}>
                                                        </div>
                                                    </div>
                                                    <div className="product-info">
                                                        <div onClick={(e) => triggerCheckBox(i)}>
                                                            <strong>{item?.products?.name}</strong>
                                                            <a className="product-info_shop">Nơi
                                                                bán: {item?.nameCooperate}</a>
                                                        </div>
                                                        <a className="btn-link mobile-remove d-block d-xl-none"
                                                           style={{width: "fit-content"}}
                                                           onClick={method.removeProduct(item?.productSimilar?.id)}>Xóa</a>
                                                        {item?.productSimilar?.productSimilarProperty?.length > 0 &&
                                                            item.productSimilar.productSimilarProperty?.map(pro => (
                                                                <p key={pro?.id}>{pro?.productPropertiesValue?.productProperties?.name}: {pro?.productPropertiesValue?.value}</p>))}
                                                        <div className="d-block d-md-none product-info__mobile">
                                                            <div className="card-price">
                                                                {
                                                                    (item?.products?.priceSale != "0") && (parseFloat(state.product?.priceSale) > parseFloat(state.price)) &&
                                                                    <span
                                                                        className="price price-old">{formatNumber(item?.products?.priceSale)}
                                                                        <u>đ</u></span>
                                                                }
                                                                <span
                                                                    className="price price-new">{formatNumber(method.productPrice(item))}<u>đ</u></span>
                                                            </div>
                                                            <div className="product-amount-group-contain">
                                                                <div className="w-193px">
                                                                    <div className="product-amount-group">
                                                                        <span className="product-amount-group-decrease"
                                                                              onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, -1)}>
                                                                            <i className="fa-solid fa-minus"></i>
                                                                        </span>
                                                                        <input type="number"
                                                                               className="product-amount-group-input"
                                                                               value={item?.quantity}
                                                                               onChange={method.changeQuantity(item?.productSimilar?.id)}/>
                                                                        <span className="product-amount-group-increase"
                                                                              onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, 1)}>
                                                                            <i className="fa-solid fa-plus"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-center d-none d-md-table-cell d-xl-none">
                                                <div className="card-price">
                                                    {
                                                        (item?.productSimilar?.price != "0" && item?.productSimilar?.price != method.productPrice(item)) &&
                                                        <span
                                                            className="price price-old">{formatNumber(item?.productSimilar?.price)}<u>đ</u></span>
                                                    }
                                                    <span
                                                        className="price price-new">{formatNumber(method.productPrice(item))}<u>đ</u></span>
                                                </div>
                                                <div className="product-amount-group-contain">
                                                    <div className="w-193px">
                                                        <div className="product-amount-group">
                                                            <span
                                                                className="product-amount-group-decrease"
                                                                onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, -1)}>
                                                                <i className="fa-solid fa-minus"></i>
                                                            </span>
                                                            <input type="number"
                                                                   className="product-amount-group-input"
                                                                   value={item?.quantity}
                                                                   onChange={method.changeQuantity(item?.productSimilar?.id)}/>
                                                            <span
                                                                className="product-amount-group-increase"
                                                                onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, 1)}>
                                                                <i className="fa-solid fa-plus"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-center d-none d-xl-table-cell">
                                                {
                                                    (item?.productSimilar?.price != "0" && item?.productSimilar?.price != method.productPrice(item)) &&
                                                    <span
                                                        className="price price-old">{formatNumber(item?.productSimilar?.price)}
                                                        <u>đ</u></span>
                                                }
                                                <span
                                                    className="price price-new">{formatNumber(method.productPrice(item))}
                                                    <u>đ</u></span>
                                            </td>
                                            <td className="text-center d-none d-xl-table-cell">
                                                <div className="product-amount-group-contain">
                                                    <div className="">
                                                        <div className="product-amount-group">
                                                        <span className="product-amount-group-decrease"
                                                              onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, -1)}>
                                                            <i className="fa-solid fa-minus"></i>
                                                        </span>
                                                            <input type="number"
                                                                   className="product-amount-group-input"
                                                                   value={item?.quantity}
                                                                   onChange={method.changeQuantity(item?.productSimilar?.id)}/>
                                                            <span className="product-amount-group-increase"
                                                                  onClick={method.increaseDecreaseQuantity(item?.productSimilar?.id, 1)}>
                                                            <i className="fa-solid fa-plus"></i>
                                                        </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="text-center d-none d-xl-table-cell">
                                                <span
                                                    className="price price-total">{formatNumber(method.totalProductPrice(item))}<u>đ</u>
                                                </span>
                                            </td>
                                            <td className="text-center d-none d-xl-table-cell">
                                                <button onClick={method.removeProduct(item?.productSimilar?.id)} title={"Xóa"}>
                                                    <i className="fa-solid fa-trash text-hover-red"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr></tr>
                            </tbody>
                        </table>
                        {state.isLoadMore && (
                            <div className="text-center mb-30px pt-10px">
                                <a className="btn btn-custom-default shopping-card-empty__button"
                                   onClick={method.fetchMoreData}>Xem thêm</a>
                            </div>)}
                        <div className="">
                            <div className="product-salary-group">
                                <div className="product-salary-group_row">
                                    <span className="product-salary-group_row__label">Tạm tính:</span>
                                    <span
                                        className="product-salary-group_row__salary_temp">{formatNumber(state.totalPrice)}
                                        <u>đ</u></span>
                                </div>
                                <div className="product-salary-group_row">
                                    <span className="product-salary-group_row__label">Tổng tiền:</span>
                                    <span
                                        className="product-salary-group_row__salary_final">{formatNumber(state.totalPrice)}
                                        <u>đ</u></span>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
        {
            (state.listProduct?.length > 0) && (
                <div className="shopping-card-footer">
                    <div className="shopping-card-footer_row_btn_continue">
                        <a className="btn btn-custom-default btn-shop-continue" href="/danh-sach-san-pham">Tiếp tục mua sắm</a>
                    </div>
                    <div className="shopping-card-footer_row_btn_order">
                        <button className="btn btn-custom-default btn-shop-order" onClick={method.checkout}>Đặt hàng</button>
                    </div>
                </div>
            )
        }
    </section>)

}

export default MainView;